var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull center pt-0 pb-3 mb-5 " },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "csHeight2" }, [
        _c(
          "div",
          { staticClass: "row justify-content-center text-left pt-2 " },
          [
            _c(
              "div",
              {
                staticClass:
                  "col-md-6 center mb-3 text-center pointer selectBlock",
                class: { blockActive: _vm.flow == "cdp" },
                on: {
                  click: function($event) {
                    _vm.flow = "cdp"
                  }
                }
              },
              [
                _c(
                  "h1",
                  { staticClass: "mt-4", class: { grey: _vm.flow == "poste" } },
                  [_c("b", [_vm._v(" CDP ")])]
                ),
                _vm._v(" "),
                _c("h4", { class: { grey: _vm.flow == "poste" } }, [
                  _vm._v("Cassa Depositi e Prestiti")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-md-6 center mb-3 text-center pointer selectBlock",
                class: { blockActive: _vm.flow == "poste" },
                on: {
                  click: function($event) {
                    _vm.flow = "poste"
                  }
                }
              },
              [
                _c(
                  "h1",
                  { staticClass: "mt-4", class: { grey: _vm.flow == "cdp" } },
                  [_c("b", [_vm._v(" Poste Italiane ")])]
                ),
                _vm._v(" "),
                _c("h4", { class: { grey: _vm.flow == "cdp" } }, [
                  _vm._v(" BancoPosta Affari")
                ])
              ]
            ),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _vm._l(_vm.disposals, function(item, index, k) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "widthFull row pt-2 mb-5",
                    class: {
                      "pt-0": k == 0,
                      even34: String(index / 2).includes(".")
                    }
                  },
                  [
                    _c("div", { staticClass: "col-md-1 " }, [
                      _c("b", [_vm._v(_vm._s(item.id))])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-2 " }, [
                      _c("b", [
                        _vm._v(
                          _vm._s(
                            _vm.moment(item.created_at).format("DD-MM-YYYY")
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-5 " },
                      [
                        item.state == 3
                          ? [
                              _vm._v(
                                "\n              Cessione completata. Attendi il bonifico bancario di\n              "
                              ),
                              _vm.flow == "cdp"
                                ? [_vm._v(" CDP ")]
                                : [_vm._v(" Poste Italiane ")],
                              _vm._v(
                                "\n              sul tuo conto corrente\n              "
                              ),
                              _vm.flow == "cdp"
                                ? [
                                    _vm._v(
                                      " indicato nei Documenti per Eleggibilità CDP "
                                    )
                                  ]
                                : [_vm._v(" BancoPosta Business ")]
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        item.state == 5
                          ? [_vm._v("\n              Errore\n            ")]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-1 center" }, [
                      _c(
                        "a",
                        { attrs: { href: item.contract } },
                        [
                          item.contract
                            ? _c("font-awesome-icon", {
                                staticClass: "green",
                                attrs: { icon: "file-alt", size: "1x" }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-1 " },
                      [
                        item.screenshot
                          ? _c("font-awesome-icon", {
                              attrs: { icon: "check", size: "1x" }
                            })
                          : item.state == 1
                          ? _c("font-awesome-icon", {
                              attrs: { icon: "spinner", spin: "", size: "1x" }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-2 text-right" }, [
                      _c("b", [
                        _vm._v(
                          "€ " +
                            _vm._s(
                              _vm._f("formatNumber")(item.totalDisposalAmount)
                            )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12 borderTop2 mt-2" }, [
                      _vm._v("\n            Derivante dalle Pratiche: "),
                      _c("b", [
                        _vm._v(_vm._s(item.practices.replaceAll(",", ", ")))
                      ])
                    ])
                  ]
                )
              ]
            })
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "widthFull row  mb-2" }, [
          _c("div", { staticClass: "col-md-8 " }),
          _vm._v(" "),
          _vm.totalDisposal != 0
            ? _c("div", { staticClass: "col-md-4 text-right" }, [
                _vm._v("\n        Importo totale Cessioni completate "),
                _c("b", [
                  _vm._v(
                    "€ " +
                      _vm._s(_vm._f("formatNumber")(_vm.totalDisposal)) +
                      " "
                  )
                ])
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "widthFull  mt-5 " },
        [
          _vm._v(
            "* Trasferimento dei crediti dal cassetto fiscale dell'installatore a quello di "
          ),
          _vm.flow == "cdp" ? [_vm._v(" CDP ")] : [_vm._v(" Poste Italiane ")]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 center mb-4" }, [
      _c("h4", [_c("b", [_vm._v("Elenco Cessioni completate")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "widthFull row even mb-2" }, [
      _c("div", { staticClass: "col-md-1 " }, [
        _c("small", [_vm._v("N.Cessione")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-2 " }, [
        _c("small", [_vm._v("Data di creazione")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-5 " }, [_c("small", [_vm._v("Stato")])]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1 " }, [
        _c("small", [_vm._v("Contratto")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1 " }, [
        _c("small", [_vm._v("Movimentazione*")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-2 text-right" }, [
        _c("small", [_vm._v("Importo di Cessione")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f6487464", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6487464","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cessioni/practicesFinished.vue
// module id = null
// module chunks = 